var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSectionStepIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{display:none}.st1{display:inline}.st5{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 11,
    y1: 539.556,
    x2: 1065.886,
    y2: 539.556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 538.44,
    cy: 539.56,
    r: 527.44,
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M372.49 786.74H704.4v-434.6H372.49v434.6zm29.58-405.02h272.75v375.43H402.07V381.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M666.01 270.31v-30.35H410.87v30.35h-98.61v568.84h452.36V270.31h-98.61zm-225.56-.76h195.97V308.25H440.46v-37.94h-.01v-.76zm294.59 540.02h-393.2V299.89h69.02v37.94H666.01v-37.94h69.03v509.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M652.25 419.99H424.63c-8.17 0-14.79 6.62-14.79 14.79 0 8.17 6.62 14.79 14.79 14.79h227.63c8.17 0 14.79-6.62 14.79-14.79 0-8.17-6.63-14.79-14.8-14.79zM652.25 484.2H424.63c-8.17 0-14.79 6.62-14.79 14.79 0 8.17 6.62 14.79 14.79 14.79h227.63c8.17 0 14.79-6.62 14.79-14.79 0-8.17-6.63-14.79-14.8-14.79zM652.25 548.4H424.63c-8.17 0-14.79 6.62-14.79 14.79 0 8.17 6.62 14.79 14.79 14.79h227.63c8.17 0 14.79-6.62 14.79-14.79 0-8.17-6.63-14.79-14.8-14.79zM652.25 612.6H424.63c-8.17 0-14.79 6.62-14.79 14.79s6.62 14.79 14.79 14.79h227.63c8.17 0 14.79-6.62 14.79-14.79s-6.63-14.79-14.8-14.79zM652.25 676.8H424.63c-8.17 0-14.79 6.62-14.79 14.79s6.62 14.79 14.79 14.79h227.63c8.17 0 14.79-6.62 14.79-14.79s-6.63-14.79-14.8-14.79z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionStepIcon1);
export default __webpack_public_path__ + "static/media/about_section_step_icon_1.e5169052330f54887442c7fb07521c6b.svg";
export { ForwardRef as ReactComponent };